import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router } from '@angular/router';
import { PermissionService } from 'src/app/service/permission.service';

@Injectable({
  providedIn: 'root'
})
export class OrdersguardService  {

  constructor(
    public permissionService: PermissionService,
    public router: Router,
) {}

  
canActivate(route: ActivatedRouteSnapshot): boolean {

    const salesModuleObject: string = route.data.moduleObject as string;

    const userPermissions = this.permissionService.getPemrissionData();
    const permission = userPermissions.some(obj => obj.objectName == salesModuleObject);

    if(!permission){
        this.router.navigate(["access"]);
    }
    return permission;
  }
}

